// BASIC CLIENT SIDE VALIDATION (FOR NOW) - CAN REPLACE WITH JQUERY VALIDATION
// Example from https://getbootstrap.com/docs/4.3/components/forms/#validation
window.addEventListener('load', function() {
	let forms = document.getElementsByClassName('form-validate');
	// Loop over them and prevent submission
	let validation = Array.prototype.filter.call(forms, function(form) {
		form.addEventListener('submit', function(e) {
			if (form.checkValidity() === false) {
				e.preventDefault();
				e.stopPropagation();
			}
			form.classList.add('was-validated');
		}, false);
	});
}, false);
